/**
 * @file 登录页面布局
 * @author hanzhichen(hanzhichen@baijiahulian.com)
 * @date 2020-01-01
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import './index.less';

const LoginLayout = ({agent: {isMobile}, children}) => (
    <div className={isMobile ? 'h5-login-container' : 'web-login-container'}>
        {children}
    </div>
);

LoginLayout.propTypes = {
    children: PropTypes.node.isRequired,
    agent: PropTypes.shape({
        isMobile: PropTypes.bool.isRequired
    }).isRequired,
};

export default connect(({agent}) => ({agent}))(LoginLayout);
